var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlatIcon',{staticClass:"icon",attrs:{"icon":"basket"},nativeOn:{"click":function($event){return _vm.addToBasket()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }